import React, { useEffect } from 'react';

import { Container } from '../../../../../symphony';

import {
	ActionType,
	IMaterialProps,
	RequestType,
} from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { SlUIComponentsRenderer } from '../../../../../shared/public/SlLearnEngine/SlUIComponentsRenderer/SlUIComponentsRenderer';
import { UIComponentType } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

export function Theory({ materialInfo }: IMaterialProps): JSX.Element {
	useEffect(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.OnTheoryMount,
			requestType: RequestType.Parallel,
			data: {
				materialInfo,
			},
		});
	}, []);

	const compClickHandler = (type: UIComponentType) => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		switch (type) {
		case UIComponentType.CodeSnippet:
			return actions$.next({
				type: ActionType.OnCodeSnippetClick,
				requestType: RequestType.Parallel,
			});
		case UIComponentType.Image:
			return actions$.next({
				type: ActionType.OnImageClick,
				requestType: RequestType.Parallel,
				data: {
					imgUrl: materialInfo.body.find(
						(el) => el.componentTypeId === UIComponentType.Image,
					).content.data,
				},
			});
		default:
			return null;
		}
	};

	return (
		<div className="le-theory" sl-test-data="cmpTheory">
			<div className="le-theory__body" sl-test-data="blTheoryBody">
				<SlUIComponentsRenderer
					components={materialInfo.body}
					onClick={compClickHandler}
				/>
			</div>
		</div>
	);
}
